import { z } from 'zod';
export const FriendStatus = z.enum(['pending', 'accepted', 'declined', 'blocked']);
export const FriendSource = z.enum(['direct_invite', 'in_room', 'username_search', 'recommendation', 're_invite']);
export const FriendOnlineStatus = z.enum(['online', 'idle', 'offline']);
export const Friend = z.object({
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    active_frame_id: z.string().nullable(),
    current_tier: z.enum(['bronze', 'silver', 'gold', 'platinum', 'diamond']),
    online_status: FriendOnlineStatus,
    current_room_id: z.string().nullable(),
    current_game_id: z.string().nullable(),
    last_seen_at: z.string().nullable(),
    source: FriendSource,
    accepted_at: z.string().nullable(),
});
export const PendingFriendRequest = z.object({
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    source: FriendSource,
    direction: z.enum(['incoming', 'outgoing']),
    created_at: z.string(),
});
export const FriendListRequest = z.object({
    status: FriendStatus.default('accepted'),
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
    sort: z.enum(['last_seen_desc', 'display_name_asc']).default('last_seen_desc'),
});
export const FriendListResponse = z.object({
    items: z.array(Friend),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
    cap: z.number().int(),
    used: z.number().int(),
});
export const FriendPendingListResponse = z.object({
    incoming: z.array(PendingFriendRequest),
    outgoing: z.array(PendingFriendRequest),
});
export const FriendRequestRequest = z.object({
    target_user_id: z.string(),
    source: FriendSource.default('username_search'),
});
export const FriendRequestResponse = z.object({
    status: z.enum(['pending', 'accepted_auto']),
    friendship: PendingFriendRequest,
});
export const FriendActionRequest = z.object({
    action: z.enum(['accept', 'decline', 'block']),
});
export const FriendActionResponse = z.object({
    user_id: z.string(),
    new_status: FriendStatus,
});
export const FriendUnfriendRequest = z.object({
    target_user_id: z.string(),
});
export const FriendBlockRequest = z.object({
    target_user_id: z.string(),
});
export const FriendUnblockRequest = z.object({
    target_user_id: z.string(),
});
export const FriendSearchRequest = z.object({
    q: z.string().min(3).max(40),
    limit: z.number().int().min(1).max(20).default(20),
});
export const FriendSearchResultItem = z.object({
    user_id: z.string(),
    username: z.string(),
    display_name: z.string(),
    avatar_url: z.string().nullable(),
    current_tier: z.enum(['bronze', 'silver', 'gold', 'platinum', 'diamond']),
    mutual_friends_count: z.number().int(),
    is_already_friend: z.boolean(),
    is_pending: z.boolean(),
});
export const FriendSearchResponse = z.object({
    items: z.array(FriendSearchResultItem),
});
export const FriendRecommendationsResponse = z.object({
    items: z.array(FriendSearchResultItem.extend({
        reason: z.enum(['shared_room', 'mutual_friends', 'recently_active']),
    })),
});
//# sourceMappingURL=friends.js.map